import { render, staticRenderFns } from "./cSplashElement.vue?vue&type=template&id=0b231f0e&"
import script from "./cSplashElement.vue?vue&type=script&lang=js&"
export * from "./cSplashElement.vue?vue&type=script&lang=js&"
import style0 from "./cSplashElement.vue?vue&type=style&index=0&id=0b231f0e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports